import "./Kanban.css";
import { useState, useEffect, useContext, useRef } from "react";
import cloneDeep from "lodash/cloneDeep";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { BeatLoader } from "react-spinners";
import { useSelector } from "react-redux";

import TaskCard from "../TaskCard";
import Modal from "antd/lib/modal/Modal";
import DrawerTask from "../DrawerTask/DrawerTask";
import ModalCreateTask from "~/pages/CreateTask/ModalCreateTask";

import ToastComponent from "../ToastComponent/ToastComponent";
import {
  TaskRoutes,
  StatusesRoutes,
  CustomCardRoutes,
  TaskFieldRoutes,
  TaskNewCommentsRoutes,
} from "../../http/routes";
import { userSelector } from "../../redux/Selectors";
import { getTask } from "../../util/util";
import { ToastContext } from "~/providers/ToastProvider";
import checkPermission from "~/helpers/checkPermission";
import CheckPermission from "~/components/CheckPermission";
import stringToSlug from "~/helpers/stringToSlug";
import {
  CheckCircleTwoTone,
  EllipsisOutlined,
  DeleteTwoTone,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
  ExperimentOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Menu, Popover, Dropdown, Modal as ModalDelete, Tooltip } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Kanban({ modalIsOpen, handleModal, searchedTask, searchedUser }) {
  const [columns, setColumns] = useState({});
  const [filteredColumns, setFilteredColumns] = useState(undefined);
  const [modalShow, setModalShow] = useState(false);
  const [isTaskDrawerLoading, setIsTaskDrawerLoading] = useState(false);
  const [modalData, setModalData] = useState({});
  const userStore = useSelector(userSelector);
  const [error, setError] = useState({ hasError: false, message: "" });
  const [statuses, setStatuses] = useState();
  const [reload, setReload] = useState(false);
  const [taskEditingData, setTaskEditingData] = useState(null);
  const { setToast } = useContext(ToastContext);
  const [tasksByStatusMap, setTasksByStatusMap] = useState({});
  const [numberOfCommentsMap, setNumberOfCommentsMap] = useState({});
  const [isLoadingMoreTasks, setIsLoadingMoreTasks] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [customCardFields, setCustomCardFields] = useState([]);

  // useEffect(() => {
  //   if (columns) {
  //     const aux = cloneDeep(columns);

  //     for (const [key, value] of Object.entries(aux)) {
  //       aux[key].items = value.items.filter((e) => {
  //         const { id, name, description, sector_name } = e;

  //         return (
  //           (id &&
  //             id
  //               .toLowerCase()
  //               .indexOf(searchedTask.replace("#", "").toLowerCase()) > -1) ||
  //           (name &&
  //             name.toLowerCase().indexOf(searchedTask.toLowerCase()) > -1) ||
  //           (description &&
  //             description.toLowerCase().indexOf(searchedTask.toLowerCase()) >
  //               -1) ||
  //           (sector_name &&
  //             sector_name.toLowerCase().indexOf(searchedTask.toLowerCase()) >
  //               -1)
  //         );
  //       });

  //       setFilteredColumns(aux);
  //     }
  //   }
  // }, [searchedTask]);

  useEffect(() => {
    const getFilteredTasks = async () => {
      const res = await TaskRoutes.getTasks(
        userStore.subprojectId,
        1,
        25,
        false,
        searchedTask,
      );

      const tasksFiltered = res.data.data.data;

      const formattedTasks = tasksFiltered?.map((task) => ({
        ...task,
        number_of_comments_not_seen_by_user:
          numberOfCommentsMap[task.id] !== undefined
            ? numberOfCommentsMap[task.id].toString()
            : task.comments_quantity,
      }));

      const aux = cloneDeep(columns);
      for (const [key, value] of Object.entries(aux)) {
        aux[key].items = formattedTasks.filter((e) => e.status_id == key);
      }

      // const columnsBack = columns.reduce((acc, elem) => {
      //   return {
      //     ...acc,
      //     [elem.id]: {
      //       id: elem.id,
      //       default_name: elem.default_name,
      //       name: elem.name,
      //       sequence: elem.sequence,
      //       items: formattedTasks || [],
      //       subproject_id: elem.subproject_id,
      //     },
      //   };
      // }, {});

      setFilteredColumns(aux);
    };
    if (searchedTask.trim() !== "" && searchedTask.length > 4) {
      getFilteredTasks();
    } else {
      setFilteredColumns(undefined);
    }
  }, [searchedTask, searchedUser, userStore.subprojectId]);

  const tasksByStatusMapRef = useRef(tasksByStatusMap);

  useEffect(() => {
    tasksByStatusMapRef.current = tasksByStatusMap;
  }, [tasksByStatusMap]);

  //TODO - Fix async states updates setModalData and setTasks
  const changeTaskValue = async (name, item, taskId, update) => {
    let taskFound = null;
    let statusIdOfTask = null;

    const currentMap = tasksByStatusMapRef.current;

    for (const [statusId, value] of Object.entries(currentMap)) {
      const found = value.tasks.find((t) => t.id == taskId);
      if (found) {
        taskFound = cloneDeep(found);
        statusIdOfTask = Number(statusId);
        break;
      }
    }

    if (!taskFound) return false;

    // Atualiza o campo desejado
    taskFound[name] = item;

    if (update) {
      try {
        const taskToUpdate = getTask(taskFound);
        taskToUpdate.status_id = taskToUpdate.status?.id || taskFound.status_id;
        taskToUpdate.priority_id = taskFound.priority_id;
        taskToUpdate.service_id = [taskToUpdate.service_id];
        taskToUpdate.start_date = transformDate(taskToUpdate.start_date);
        taskToUpdate.due_date = transformDate(taskToUpdate.due_date);

        await TaskRoutes.updateTask(
          taskToUpdate,
          taskId,
          userStore.subprojectId,
        );

        setModalData((prevData) => ({ ...prevData, ...taskFound }));
      } catch (err) {
        if (
          err.response?.data?.message ===
          "Formulários obrigatórios não preenchidos!"
        ) {
          setToast({
            type: "error",
            title: "Erro!",
            message: `${err.response.data.message}`,
            show: true,
            autohide: true,
          });
        } else {
          console.error(err);
          return false;
        }
      }
    }

    // Verifica se o status mudou
    const newStatusId = taskFound.status?.id ?? statusIdOfTask;
    const movedToAnotherColumn = newStatusId != statusIdOfTask;
    if (!movedToAnotherColumn) return false;

    setTasksByStatusMap((prevMap) => {
      const oldTasks = prevMap[statusIdOfTask]?.tasks || [];
      const newTasks = prevMap[newStatusId]?.tasks || [];

      const updatedOldTasks = oldTasks.filter((t) => t.id !== taskId);
      const updatedNewTasks = movedToAnotherColumn
        ? [...newTasks, taskFound]
        : newTasks.map((t) => (t.id === taskId ? taskFound : t));

      return {
        ...prevMap,
        [statusIdOfTask]: {
          ...prevMap[statusIdOfTask],
          tasks: updatedOldTasks,
        },
        [newStatusId]: {
          ...prevMap[newStatusId],
          tasks: updatedNewTasks,
          page: prevMap[newStatusId]?.page || 1,
          perPage: prevMap[newStatusId]?.perPage || 20,
          total: prevMap[newStatusId]?.total || 0,
          hasMore: prevMap[newStatusId]?.hasMore ?? true,
        },
      };
    });

    setColumns((prev) => ({
      ...prev,
      [statusIdOfTask]: {
        ...prev[statusIdOfTask],
        items: prev[statusIdOfTask].items.filter((t) => t.id !== taskId),
      },
      [newStatusId]: {
        ...prev[newStatusId],
        items: movedToAnotherColumn
          ? [...prev[newStatusId]?.items, taskFound]
          : prev[newStatusId]?.items.map((t) =>
              t.id === taskId ? taskFound : t,
            ),
      },
    }));

    return true;
  };

  function transformDate(date) {
    let newDate;

    try {
      const [dateComp, timeComp] = date.split(" ");
      const [day, month, year] = dateComp.split("/");
      const [hours, min, sec] = timeComp.split(":");

      newDate = new Date(
        +year,
        month - 1,
        +day,
        +hours - 3,
        +min,
        +sec,
      ).getTime();
    } catch {
      newDate = null;
    }

    return newDate;
  }

  const editTask = async (id) => {
    const res = await TaskRoutes.getTask(userStore.subprojectId, id);
    const taskData = res.data.data;

    setTaskEditingData(taskData);

    handleModal();
  };

  const clearTaskNewComments = async (companyId, taskId, statusId) => {
    await TaskNewCommentsRoutes.postLastUserView(companyId, taskId);

    setColumns((prevData) => {
      const newData = { ...prevData };

      const column = newData[statusId];
      if (!column || !Array.isArray(column.items)) return prevData;

      const taskIndex = column.items.findIndex((task) => task.id === taskId);
      if (taskIndex === -1) return prevData;

      column.items[taskIndex] = {
        ...column.items[taskIndex],
        number_of_comments_not_seen_by_user: 0,
      };

      return newData;
    });
  };

  const onDragEnd = async (result, columns, setColumns) => {
    function cantChangeStatusToast() {
      return setToast({
        type: "warning",
        title: "Aviso!",
        message:
          "Você não tem permissão para alterar a tarefa para este status!",
        show: true,
        autohide: true,
      });
    }

    if (
      (!checkPermission("modificar-status-exceto-concluido") &&
        !checkPermission("modificar-status-concluido")) ||
      (!checkPermission("modificar-status-exceto-concluido") &&
        checkPermission("modificar-status-concluido") &&
        stringToSlug(columns[result.destination.droppableId].name) !==
          "concluido") ||
      (checkPermission("modificar-status-exceto-concluido") &&
        !checkPermission("modificar-status-concluido") &&
        stringToSlug(columns[result.destination.droppableId].name) ===
          "concluido") ||
      isUserBlockedToEdit(result.source.droppableId)
    ) {
      return cantChangeStatusToast();
    }

    const refColumn = filteredColumns ? filteredColumns : columns;

    const taskMoved = refColumn[result.source.droppableId].items.find(
      (elem) => elem.id === result.draggableId,
    );

    if (!result.destination) return;

    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = refColumn[source.droppableId];
      const destColumn = refColumn[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);

      destItems.splice(destination.index, 0, {
        ...removed,
        status_id: result.destination.droppableId,
        status_name: columns[result.destination.droppableId].name,
        number_of_comments_not_seen_by_user:
          removed.number_of_comments_not_seen_by_user,
        priority_color: removed.priority_color,
        priority_name: removed.priority_name,
        status: {
          id: result.destination.droppableId,
          name: columns[result.destination.droppableId].name,
        },
      });

      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
      if (filteredColumns) {
        setFilteredColumns({
          ...filteredColumns,
          [source.droppableId]: {
            ...sourceColumn,
            items: sourceItems,
          },
          [destination.droppableId]: {
            ...destColumn,
            items: destItems,
          },
        });
      }

      await TaskRoutes.updateTask(
        {
          ...taskMoved,
          status_id: result.destination.droppableId,
          service_id: taskMoved.services.map((s) => s.id),
          start_date: transformDate(taskMoved.start_date),
          due_date: transformDate(taskMoved.due_date),
        },
        result.draggableId,
        userStore.subprojectId,
      )
        .then((res) => {
          setToast({
            type: "success",
            title: "Sucesso!",
            message: ` Tarefa ${res.data.data.id} movida com sucesso! `,
            show: true,
            autohide: true,
          });
        })
        .catch((err) => {
          if (
            err.response.data.message ===
            "Formulários obrigatórios não preenchidos!"
          ) {
            setToast({
              type: "error",
              title: "Erro!",
              message: `${err.response.data.message}`,
              show: true,
              autohide: true,
            });
          }

          getDaily();
        });
    } else {
      // const column = columns[source.droppableId];
      // const copiedItems = [...column.items];
      // const [removed] = copiedItems.splice(source.index, 1);
      // copiedItems.splice(destination.index, 0, removed);
      // setColumns({
      //   ...columns,
      //   [source.droppableId]: {
      //     ...column,
      //     items: copiedItems,
      //   },
      // });
      // setFilteredColumns({
      //   ...filteredColumns,
      //   [source.droppableId]: {
      //     ...column,
      //     items: copiedItems,
      //   },
      // });
    }
  };

  useEffect(() => {
    if (userStore.subprojectId || reload) {
      getDaily();
    }
  }, [userStore.subprojectId, searchedUser]);

  const getCustomCardFields = async () => {
    const customCardFields = await CustomCardRoutes.getCustomCardBySubproject(
      userStore.companyId,
      userStore.subprojectId,
    );

    const customCardData = customCardFields.data.data;

    if ("form_field" in customCardData) {
      const fieldResponse = await TaskFieldRoutes.findByLabel(
        encodeURIComponent(customCardData.form_field),
      );
      customCardData["form_field_results"] = fieldResponse.data.data;
    }

    if ("blocked_field" in customCardData) {
      const fieldResponse = await TaskFieldRoutes.findByLabel(
        encodeURIComponent(customCardData.blocked_field),
      );
      customCardData["blocked_field_results"] = fieldResponse.data.data;
    }

    setCustomCardFields(customCardData);
  };

  const getDaily = async () => {
    setReload(true);

    try {
      const [columnsResponse, numberOfCommentsResponse] = await Promise.all([
        StatusesRoutes.getStatus(userStore.companyId, userStore.subprojectId),
        TaskNewCommentsRoutes.getNumberOfCommentsNotSeenByUser(
          userStore.companyId,
        ),
      ]);

      const columnsData = columnsResponse.data.data;

      const tasksByStatusMapTemp = {};
      const numberOfCommentsArray = numberOfCommentsResponse.data.data;

      const numberOfCommentsMap = numberOfCommentsArray.reduce(
        (acc, comment) => {
          acc[comment.task_id] = comment.commentsNotSeen;
          return acc;
        },
        {},
      );

      await Promise.all(
        columnsData.map(async (status) => {
          const response = await TaskRoutes.listByStatus(
            userStore.subprojectId,
            searchedUser,
            status.id,
            1,
            10,
            false,
          );

          const resData = response.data.data;

          const formattedTasks = resData.data.map((task) => ({
            ...task,
            observers_quantity: task.observer_ids.length,
            number_of_comments_not_seen_by_user:
              numberOfCommentsMap[task.id] !== undefined
                ? numberOfCommentsMap[task.id].toString()
                : task.comments_quantity,
          }));

          tasksByStatusMapTemp[status.id] = {
            tasks: formattedTasks,
            page: resData.page,
            perPage: resData.perPage,
            total: resData.total,
            hasMore: resData.hasMore,
          };
        }),
      );

      const columnsBack = columnsData.reduce((acc, elem) => {
        return {
          ...acc,
          [elem.id]: {
            id: elem.id,
            default_name: elem.default_name,
            name: elem.name,
            sequence: elem.sequence,
            items: tasksByStatusMapTemp[elem.id]?.tasks || [],
            subproject_id: elem.subproject_id,
          },
        };
      }, {});

      setStatuses(columnsData);
      setNumberOfCommentsMap(numberOfCommentsMap);
      setTasksByStatusMap(tasksByStatusMapTemp);
      setColumns(columnsBack);
      // setFilteredColumns(columnsBack);
      getCustomCardFields();
    } catch (error) {
      setColumns(null);
      setError({ message: error.message, hasError: true });
    } finally {
      setReload(false);
    }
  };

  const loadMoreTasks = async (statusId) => {
    setIsLoadingMoreTasks(true);
    const current = tasksByStatusMap[statusId];

    if (!current || !current.hasMore) return;

    const nextPage = current.page + 1;

    const response = await TaskRoutes.listByStatus(
      userStore.subprojectId,
      searchedUser,
      statusId,
      nextPage,
      current.perPage,
      false,
    );

    const resData = response.data.data;

    const updatedTasks = [
      ...current.tasks,
      ...resData.data.map((task) => ({
        ...task,
        number_of_comments_not_seen_by_user:
          numberOfCommentsMap[task.id] !== undefined
            ? numberOfCommentsMap[task.id].toString()
            : task.comments_quantity,
      })),
    ];

    setTasksByStatusMap((prev) => ({
      ...prev,
      [statusId]: {
        tasks: updatedTasks,
        page: resData.page,
        perPage: resData.perPage,
        total: resData.total,
        hasMore: resData.hasMore,
      },
    }));

    setColumns((prev) => ({
      ...prev,
      [statusId]: {
        ...prev[statusId],
        items: updatedTasks,
      },
    }));

    // setFilteredColumns((prev) => ({
    //   ...prev,
    //   [statusId]: {
    //     ...prev[statusId],
    //     items: updatedTasks,
    //   },
    // }));
    setIsLoadingMoreTasks(false);
  };

  const handleCardClick = async (id) => {
    try {
      setIsTaskDrawerLoading(true);
      setModalShow(true);

      const res = await TaskRoutes.getTask(userStore.subprojectId, id);
      const task = res.data.data;

      setModalData({ ...task, statuses });
      setIsTaskDrawerLoading(false);
    } catch (err) {
      setToast({
        type: "error",
        title: "Erro!",
        message: "Um erro ocorreu ao abrir a tarefa!",
        show: true,
        autohide: true,
      });

      setIsTaskDrawerLoading(false);
      setModalShow(false);
    }
  };

  const handleDeleteTask = async (id) => {
    try {
      setColumns((prevColumns) => {
        const updatedColumns = {};
        for (const columnId in prevColumns) {
          updatedColumns[columnId] = {
            ...prevColumns[columnId],
            items: prevColumns[columnId].items.filter((task) => task.id !== id),
          };
        }
        return updatedColumns;
      });

      // setFilteredColumns((prevFilteredColumns) => {
      //   const updatedFilteredColumns = {};
      //   for (const columnId in prevFilteredColumns) {
      //     updatedFilteredColumns[columnId] = {
      //       ...prevFilteredColumns[columnId],
      //       items: prevFilteredColumns[columnId].items.filter(
      //         (task) => task.id !== id,
      //       ),
      //     };
      //   }
      //   return updatedFilteredColumns;
      // });

      await TaskRoutes.removeTask(id);

      setToast({
        type: "success",
        title: "Ok!",
        message: "Tarefa excluída com sucesso!",
        show: true,
        autohide: true,
      });
    } catch (error) {
      setToast({
        type: "error",
        title: "Erro!",
        message: "Um erro ocorreu ao excluir a tarefa!",
        show: true,
        autohide: true,
      });
      console.error("Erro ao excluir tarefa:", error);
      getDaily();
    }
  };

  const handleToFile = (taskId, columnId) => {
    setTasksByStatusMap((prevMap) => {
      const current = prevMap[columnId];

      if (!current) return prevMap;

      const updatedTasks = current.tasks.filter((task) => task.id !== taskId);

      return {
        ...prevMap,
        [columnId]: {
          ...current,
          tasks: updatedTasks,
        },
      };
    });

    setColumns((prevColumns) => {
      const updatedColumn = {
        ...prevColumns[columnId],
        items: prevColumns[columnId].items.filter((task) => task.id !== taskId),
      };

      return {
        ...prevColumns,
        [columnId]: updatedColumn,
      };
    });

    // setFilteredColumns((prevFiltered) => {
    //   const updatedFilteredColumn = {
    //     ...prevFiltered[columnId],
    //     items: prevFiltered[columnId].items.filter(
    //       (task) => task.id !== taskId,
    //     ),
    //   };

    //   return {
    //     ...prevFiltered,
    //     [columnId]: updatedFilteredColumn,
    //   };
    // });
  };

  const handleClose = () => {
    setError({ message: "", hasError: false });
  };

  async function deleteStatus(status) {
    await StatusesRoutes.deleteById(userStore.companyId, status);
    setColumns((prevColumns) => {
      const newColumns = { ...prevColumns };
      delete newColumns[status];
      return newColumns;
    });
    // setFilteredColumns((prevFilteredColumns) => {
    //   const newFilteredColumns = { ...prevFilteredColumns };
    //   delete newFilteredColumns[status];
    //   return newFilteredColumns;
    // });
    setStatuses((prevStatuses) => prevStatuses.filter((s) => s.id !== status));

    setToast({
      type: "success",
      title: "Sucesso!",
      message: "Coluna excluida!",
      show: true,
      autohide: true,
    });
  }

  async function handleNewList() {
    let companyId = userStore.companyId;

    let initialStatus = {
      statuses: [
        {
          name: "NOVA LISTA",
          subprojectId: userStore.subprojectId,
        },
      ],
    };

    await StatusesRoutes.save(companyId, initialStatus);
    getDaily();
    setToast({
      type: "success",
      title: "Sucesso!",
      message: "Novo status criado com sucesso!",
      show: true,
      autohide: true,
    });
  }

  const closeCreateModal = () => {
    setTaskEditingData(null);
    handleModal();
  };

  const sensor = (api) => {
    // console.log({ api });
  };

  async function changeStatusSequence(columnId, _direction) {
    let companyId = userStore.companyId;
    let subprojectId = userStore.subprojectId;

    let direction = { direction: _direction };

    try {
      const res = await StatusesRoutes.updateSequence(
        companyId,
        subprojectId,
        columnId,
        direction,
      );
      const updatedStatuses = res.data.data;

      const newColumns = {};
      const newStatusesArray = [];

      const currentItemsMap = {};
      for (const colId in columns) {
        currentItemsMap[colId] = columns[colId].items;
      }

      updatedStatuses.forEach((status) => {
        newColumns[status.id] = {
          id: status.id,
          default_name: status.default_name,
          name: status.name,
          sequence: status.sequence,
          items: currentItemsMap[status.id] || [],
          subproject_id: status.subproject_id,
          loggedUserRestrictions: status.loggedUserRestrictions,
        };
        newStatusesArray.push(status);
      });

      setColumns(newColumns);
      // setFilteredColumns(newColumns);
      setStatuses(newStatusesArray);

      setToast({
        type: "success",
        title: "Sucesso!",
        message: "Posição da coluna alterada!",
        show: true,
        autohide: true,
      });
    } catch (error) {
      setToast({
        type: "error",
        title: "Erro!",
        message: "Um erro ocorreu ao alterar a posição da coluna!",
        show: true,
        autohide: true,
      });
      getDaily();
    }
  }

  const { confirm } = ModalDelete;

  const showConfirmDeleteTaskModal = (columnId) => {
    confirm({
      icon: <ExclamationCircleOutlined style={{ fontSize: "3em" }} />,
      content: `Tem certeza que deseja excluir a coluna?`,
      okText: "Excluir",
      okButtonProps: {
        style: {
          alignContent: "center",
          display: "inline-flex",
          alignItems: "center",
          alignSelf: "center",
        },
        danger: true,
        icon: <DeleteOutlined></DeleteOutlined>,
      },
      cancelText: "Cancelar",
      closable: true,
      onOk() {
        deleteStatus(columnId);
      },
    });
  };

  const isUserBlockedToEdit = (status_id) => {
    const statusesBlockedToEdit = statuses
      .filter((column) => column.loggedUserRestrictions.blockedToEdit)
      .map((column) => column.id.toString());
    return statusesBlockedToEdit.includes(status_id.toString());
  };

  function renderColumns() {
    if (
      !columns ||
      Object.keys(columns).length === 0 ||
      reload ||
      !userStore.subprojectId
    )
      return (
        <div className="w-100 d-flex justify-content-center">
          <BeatLoader color="#000000" size={20} />
        </div>
      );

    return (
      <DragDropContext
        sensors={[sensor]}
        onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
      >
        {Object.entries(filteredColumns || columns || {})
          .sort(([, a], [, b]) => a.sequence - b.sequence)
          .filter(([_, item]) => {
            if (
              typeof item.subproject_id === "string" &&
              item.subproject_id.includes("#")
            ) {
              return true; // Mantém o item se subproject_id contém #
            }
            return item.subproject_id == userStore.subprojectId; // Aplica o filtro normal caso contrário
          })
          .map(([columnId, column]) => {
            const { name, items, default_name, sequence } = column;

            const orderedColumns = Object.entries(columns).sort(
              ([, a], [, b]) => a.sequence - b.sequence,
            );

            function isFirst(columnId) {
              return columnId === orderedColumns[0][0];
            }

            function isLast(columnId) {
              return (
                columnId === orderedColumns[orderedColumns.length - 1][0] ||
                columnId === orderedColumns[orderedColumns.length - 2][0]
              );
            }

            const columnName = default_name === null ? name : default_name;

            const menu = (
              <Menu>
                {columnName !== "CONCLUÍDO" && (
                  <Menu.ItemGroup title="Editar">
                    <Menu.Item>
                      <button
                        style={{
                          display: "flex",
                          backgroundColor: "rgba(128, 128, 128, 0)",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontWeight: 500,

                          color: "#585858",
                        }}
                        onClick={() => showConfirmDeleteTaskModal(columnId)}
                      >
                        <DeleteTwoTone
                          twoToneColor="#FF7875"
                          className="mr-2"
                        ></DeleteTwoTone>{" "}
                        Deletar
                      </button>
                    </Menu.Item>
                  </Menu.ItemGroup>
                )}
                {columnName !== "CONCLUÍDO" && (
                  <Menu.ItemGroup title="Mover Posição">
                    {!isLast(columnId) && (
                      <Menu.Item>
                        <button
                          style={{
                            display: "flex",
                            backgroundColor: "rgba(128, 128, 128, 0)",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight: 500,
                            color: "#585858",
                          }}
                          onClick={() =>
                            changeStatusSequence(columnId, "right")
                          }
                        >
                          <ArrowRightOutlined
                            style={{ color: "#27AE60" }}
                            className="mr-2"
                          ></ArrowRightOutlined>{" "}
                          Direita
                        </button>
                      </Menu.Item>
                    )}
                    {!isFirst(columnId) && (
                      <Menu.Item>
                        <button
                          style={{
                            display: "flex",
                            backgroundColor: "rgba(128, 128, 128, 0)",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight: 500,
                            color: "#585858",
                          }}
                          onClick={() => changeStatusSequence(columnId, "left")}
                        >
                          <ArrowLeftOutlined
                            style={{ color: "#27AE60" }}
                            className="mr-2"
                          ></ArrowLeftOutlined>{" "}
                          Esquerda
                        </button>
                      </Menu.Item>
                    )}
                  </Menu.ItemGroup>
                )}
                <Menu.ItemGroup title="Status">
                  <Menu.Item>
                    <Link to={`/home/projects/status/${columnId}`}>
                      <button
                        style={{
                          display: "flex",
                          backgroundColor: "rgba(128, 128, 128, 0)",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontWeight: 500,
                          color: "#585858",
                        }}
                      >
                        <ExperimentOutlined
                          style={{ color: "blue" }}
                          className="mr-2"
                        />
                        Editar Status
                      </button>
                    </Link>
                  </Menu.Item>
                </Menu.ItemGroup>
              </Menu>
            );

            return (
              <div className="kanban-wrapper" key={columnId}>
                <div className="editStatus">
                  <h4 className="kanban-title">
                    {name}
                    {columnName === "CONCLUÍDO" && (
                      <Popover
                        content={
                          "Todas as tarefas desse status serão concluídas!"
                        }
                        title="Final de fluxo"
                      >
                        <div className="kanban-info-title">
                          <CheckCircleTwoTone twoToneColor="#52c41a" />
                        </div>
                      </Popover>
                    )}
                  </h4>

                  <CheckPermission slug="atualizar-status">
                    <Dropdown overlay={menu} trigger={["click"]}>
                      <div className="edit-column-button">
                        <EllipsisOutlined
                          style={{
                            color: "#585858",

                            fontSize: "25px",
                          }}
                        ></EllipsisOutlined>
                      </div>
                    </Dropdown>
                  </CheckPermission>
                </div>

                <div
                  className="kanban-tasks-list"
                  style={{
                    maxHeight: window.innerHeight - 335,
                  }}
                >
                  <Droppable droppableId={columnId} key={columnId}>
                    {(provided) => {
                      return (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            padding: 4,
                            width: 360,
                            minHeight: 500,
                          }}
                        >
                          {items.map((item, index) => {
                            const { id } = item;

                            return (
                              <Draggable
                                key={id}
                                draggableId={id}
                                index={index}
                              >
                                {(provided, snapshot) => {
                                  const {
                                    id,
                                    name,
                                    description,
                                    status_name,
                                    sector_name,
                                    service_name,
                                    priority_name,
                                    priority_color,
                                    responsible_photo,
                                    date_closed,
                                    due_date,
                                    start_date,
                                    comments_quantity,
                                    number_of_comments_not_seen_by_user,
                                    attachments_quantity,
                                    observers_quantity,
                                    fields_quantity,
                                    filled_fields,
                                    days_late,
                                    status_id,
                                  } = item;

                                  return (
                                    <TaskCard
                                      id={id}
                                      name={name}
                                      onFinishChangeSubproject={getDaily}
                                      description={description}
                                      statusName={status_name}
                                      sectorName={sector_name}
                                      serviceName={service_name}
                                      priorityName={priority_name}
                                      priorityColor={priority_color}
                                      responsiblePhoto={responsible_photo}
                                      dateClosed={date_closed}
                                      dueDate={due_date}
                                      startDate={start_date}
                                      commentsQuantity={comments_quantity}
                                      numberOfCommentsNoSeenByUser={
                                        number_of_comments_not_seen_by_user?.toString() ??
                                        "0"
                                      }
                                      attachmentsQuantity={attachments_quantity}
                                      observersQuantity={observers_quantity}
                                      fieldsQuantity={fields_quantity}
                                      filledFields={filled_fields}
                                      daysLate={days_late}
                                      provided={provided}
                                      snapshot={snapshot}
                                      handleCardClick={handleCardClick.bind(
                                        null,
                                        id,
                                      )}
                                      onToFile={(taskId) =>
                                        handleToFile(taskId, columnId)
                                      }
                                      handleDeleteTask={handleDeleteTask}
                                      customFields={customCardFields}
                                      isUserBlockedToEdit={isUserBlockedToEdit(
                                        status_id,
                                      )}
                                    />
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                          {tasksByStatusMap[columnId]?.hasMore &&
                            !filteredColumns && (
                              <div
                                key={columnId}
                                style={{
                                  marginTop: "24px",
                                  textAlign: "center",
                                }}
                              >
                                <Tooltip
                                  color="#188fff8a"
                                  placement="bottom"
                                  title="Clique para carregar mais Tarefas"
                                  showArrow={false}
                                  open={isHovered === columnId}
                                >
                                  <button
                                    onMouseEnter={() => setIsHovered(columnId)}
                                    onMouseLeave={() => setIsHovered("false")}
                                    disabled={isLoadingMoreTasks}
                                    onClick={() => {
                                      loadMoreTasks(columnId);
                                      setIsHovered("false");
                                    }}
                                    style={{
                                      // border: "none",
                                      backgroundColor:
                                        isHovered === columnId ? "#1890FF" : "",
                                      width: "40%",
                                      padding: "10px 20px",
                                      borderRadius: "20px",
                                    }}
                                  >
                                    <SyncOutlined
                                      style={{
                                        fontSize: "24px",
                                        color:
                                          isHovered === columnId
                                            ? "white"
                                            : "#1890FF",
                                      }}
                                      // spin={isHovered === columnId}
                                    />
                                  </button>
                                </Tooltip>
                              </div>
                            )}
                        </div>
                      );
                    }}
                  </Droppable>
                </div>
              </div>
            );
          })}
        <div>
          <button className="kanban-new-list" onClick={() => handleNewList()}>
            + Adicionar novo status
          </button>
        </div>
      </DragDropContext>
    );
  }

  return (
    <div className="kanban-container">
      <ToastComponent
        delay="5000"
        title="Ops! Houve um erro"
        description={error.message}
        type="error"
        showToast={error.hasError}
        handleClose={handleClose}
      />
      {modalShow && (
        <DrawerTask
          show={modalShow}
          loading={isTaskDrawerLoading}
          onClose={() => setModalShow(false)}
          data={modalData}
          changeTaskValue={changeTaskValue}
          handleEditTask={editTask}
          afterSaveForm={getDaily}
          afterAddField={getDaily}
          handleViewNewComments={clearTaskNewComments}
        />
      )}

      {renderColumns()}

      <Modal
        width="60%"
        className="modal-projects"
        centered
        visible={modalIsOpen}
        onCancel={closeCreateModal}
        title="Cadastro de tarefa"
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <ModalCreateTask
          handleClose={closeCreateModal}
          refreshList={getDaily}
          taskEditingData={taskEditingData}
        />
      </Modal>
      {/* <UpdateStatusModal
        isVisible={isUpdateStatusModalVisible}
        statusId={statusClickedToEdit}
        subprojectId={userStore.subprojectId}
        companyId={userStore.companyId}
        onCancel={handleUpdateStatusModalCancel}
        onSuccess={handleUpdateStatusModalSuccess}
      /> */}
      {/* <HideStatusModal
        isVisible={isHideStatusModalVisible}
        statusId={statusClickedToEdit}
        onCancel={() => setIsHideStatusModalVisible(false)}
        onSuccess={() => setIsHideStatusModalVisible(false)}
      /> */}
    </div>
  );
}

export default Kanban;
